/* eslint-disable import/no-namespace */
import { initialuserstate } from '../initialuserstate'
import * as types from '../actions'

export default function user (state=initialuserstate,action){
 
    switch (action.type) {
        
        case types.user.CHECK_USER_ROLE:
        {                 
            const isAdministrator = action.payload.data
            return Object.assign({},state,{ isAdministrator })         
        }
        case types.user.GET_USER_ROLE:
        {   
            // console.log(' types.user.GET_USER_ROLE  action.payload',action.payload)              
            const { roleName, status } = action.payload
            return { ...state,roleName,status, roleChecked:true,checkingRole:false }       
        }
        case types.user.CHECKING_USER_ROLE:
        {   
            // console.log(' types.user.CHECKING_USER_ROLE')              
            return { ...state, checkingRole:true }       
        }
        case types.user.SET_USER_ROLE:
        {
            const roleName = action.payload.roleName
            return Object.assign({},state,{ roleName, roleChecked:true }) 
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_user.js